import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Paper,
  Typography,
  Box,
  Snackbar,
  Alert,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useHistory } from "react-router-dom";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import useHttp from "../../Hooks/use-http";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
// import DriverRegistrationDriverDocument from "./DriverRegistrationDriverDocument";
import DriverRegistrationDriverDocument from "./DriverRegistrationDriverDocument";

const DriverRegistration = () => {
  const location = useLocation();
  const setIsApiCall = location.state || {};
  const [partnerEmailOptions, setPartnerEmailOptions] = useState([]);
  const [vehicleCustom, setVehicleCustom] = useState(false);
  const [driverDocuments, setDriverDocuments] = useState([]);
  const [driverIsUploading, setDriverIsUploading] = useState(false);
  const [countryCode, setCountryCode] = useState("91"); // Default country code

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const history = useHistory();
  const [emailError, setEmailError] = useState(false);

  const [formValues, setFormValues] = useState({
    emailID: "",
    fName: "",
    lName: "",
    partnerselected: "",
    partnerPassword: "",
    mobileNumber: "",
    partnerEmailID: "",
    partnerMobileNumber: "",
    // partnerName: "",
    partnerFullname: "",
    selectedVehicle: "",
    address: "",
    fuelType: "",
    vehicleType: "",
    gender: "",
    zipCode: "",
    vehicleNumber: "",
    vehicleColor: "",
    vehicleModel: "",
    vehicleMaker: "",
    city: "Ahmedabad",
    country: "India",
    driverType: "",
    // dateOfBirth: null,
    password: "",
  });

  const [step, setStep] = useState(1);

  const { sendRequest, isLoading } = useHttp();

  const parseApiErrorMessage = (response, fallbackError) => {
    const sources = [response?.message, response?.statusMessage, fallbackError];

    for (const source of sources) {
      if (!source || typeof source !== "string") continue;

      if (source.includes("{")) {
        try {
          const parsed = JSON.parse(source.substring(source.indexOf("{")));
          if (parsed?.message) return parsed.message;
          if (parsed?.statusMessage) return parsed.statusMessage;
        } catch {
          // use raw string below
        }
      }

      return source;
    }

    return "Failed to save documents. Please try again.";
  };

  const showFinishError = (response, fallbackError) => {
    const errorMsg = parseApiErrorMessage(response, fallbackError);
    setSnackbarMessage(errorMsg);
    toast.error(errorMsg);
    setSnackbarOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
    if (name === "emailID") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setEmailError(!emailRegex.test(value));
    }
  };
  useEffect(() => {
    sendRequest(
      {
        url: "/partnerwithvehicle",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: { emailID: localStorage.getItem("user") },
      },
      (data) => {
        const filterPartner = data?.partnerwithvehicle?.filter(
          (el) => el.isSuspended == false
        );
        // setPartnerEmailOptions(data.partnerwithvehicle); // Adjust API response parsing as needed
        setPartnerEmailOptions(filterPartner);
      }
    );
  }, []);

  const handleNext = () => {
    setStep(2);
  };

  const handleBack = () => setStep((prev) => prev - 1);

  const handleNextStep2 = async (e) => {
    e.preventDefault();

    // Add country code to mobile number
    const mobileNumberWithCountryCode = countryCode + formValues.mobileNumber;
    const partnerMobileNumberWithCountryCode =
      countryCode + formValues.partnerMobileNumber;

    const driverPayload = {
      emailID: localStorage.getItem("user"),
      data: {
        fName: formValues.fName,
        lName: formValues.lName,
        emailID: formValues.emailID,
        // mobileNumber: formValues.mobileNumber,
        mobileNumber: mobileNumberWithCountryCode,

        partnerEmailID:
          formValues.partnerselected === "custom"
            ? formValues.partnerEmailID //new
            : formValues.partnerselected, //old

        // if partner is custom then new insertion-------------------------
        isNewPartner: formValues.partnerselected === "custom",
        // if partnerselected is custom, set flag to 1
        //then emailID of partner will be partnerEmailID
        partnerFullName: formValues.partnerFullname,

        partnerPassword: formValues.partnerPassword,

        // partnerMobileNumber: formValues.partnerMobileNumber,
        partnerMobileNumber: partnerMobileNumberWithCountryCode,

        // -----------------------------------------------------------------------

        address: formValues.address,
        gender: formValues.gender,
        zipCode: formValues.zipCode,
        vehicleNumber:
          formValues.selectedVehicle === "custom"
            ? formValues.vehicleNumber
            : formValues.selectedVehicle,

        // if vehicle is custom then new insertion-------------------------
        isNewVehicle: formValues.selectedVehicle === "custom",

        // regNumber:
        //   formValues.selectedVehicle === "custom"
        //     ? formValues.vehicleNumber
        //     : formValues.selectedVehicle,

        color: formValues.vehicleColor,
        model: formValues.vehicleModel,
        maker: formValues.vehicleMaker,
        // partnerEmailID:
        //   formValues.partnerselected === "custom"
        //     ? formValues.partnerEmailID
        //     : formValues.partnerselected,
        vehicleType: formValues.vehicleType,
        fuelType: formValues.fuelType,

        // -----------------------------------------------------------------------------
        city: formValues.city,
        country: formValues.country,
        driverType: formValues.driverType,
        password: formValues.password,
      },
    };

    try {
      sendRequest(
        {
          url: "/registerdriver",
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: driverPayload,
        },
        (response) => {
          // Handle the response here if needed
          let resData = response;

          // If it's an error string (e.g., 'Error: 400 - {...}')
          if (typeof response === "string" && response.includes("{")) {
            const jsonStr = response.substring(response.indexOf("{"));
            resData = JSON.parse(jsonStr);
          }

          if (resData.status === 200 || resData.status === 201) {
            toast.success(resData.message || "Driver registered successfully");
            // setIsApiCall(true); // Trigger API call to refresh data

            setStep(3);
          } else {
            // If there's an error, show a toast notification
            toast.error(resData.message || "Error registering the driver");
          }
        }
      );
    } catch (error) {
      console.error("Error in API calls:", error);
      toast.error(error.message || "An unexpected error occurred");
    }
  };

  const handleSubmit = async () => {
    const missingRequired = driverDocuments.filter(
      (doc) => doc.required && (!doc.isUploaded || !doc.url)
    );

    if (missingRequired.length > 0) {
      const names = missingRequired.map((doc) => doc.name).join(", ");
      const errorMsg = `Please upload all required documents: ${names}`;
      setSnackbarMessage(errorMsg);
      toast.error(errorMsg);
      setSnackbarOpen(true);
      return;
    }

    const uploadedDocs = driverDocuments.filter(
      (doc) => doc.isUploaded && doc.url
    );

    const payload = uploadedDocs.map((doc) => {
      const docPayload = {
        documentID: doc.documentID,
        category: doc.category,
        documentNumber: doc.number || "",
        documentURL: doc.url,
        type: doc.type,
        isVerified: doc.required ? 0 : null,
        ...(doc.category === "Driver" && { emailID: formValues.emailID }),
        ...(doc.category === "Vehicle" && {
          numberPlate:
            formValues.selectedVehicle !== "custom"
              ? formValues.selectedVehicle
              : formValues.vehicleNumber,
        }),
      };

      if (doc.hasExpiry && doc.expiryDate) {
        docPayload.expiryDate = doc.expiryDate;
      }

      return docPayload;
    });

    try {
      let requestError = null;

      const response = await sendRequest(
        {
          url: "/addupdatedocument",
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: { emailID: localStorage.getItem("user"), data: payload },
        },
        (data) => {
          if (typeof data === "string") {
            requestError = data;
          }
        }
      );

      if (requestError || !response) {
        showFinishError(response, requestError);
        return;
      }

      const isSuccess =
        response?.status === 200 ||
        response?.status === 201 ||
        response?.status === "200" ||
        response?.status === "201";

      if (isSuccess) {
        setSnackbarMessage("Documents uploaded successfully!");
        toast.success("Documents uploaded successfully!");
        setSnackbarOpen(true);
        history.push("/drivers");
      } else {
        showFinishError(response);
      }
    } catch (error) {
      showFinishError(null, error.message);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Paper
        elevation={3}
        style={{
          padding: "40px",
          borderRadius: "15px",
          maxWidth: "700px",
          margin: "30px auto",
          boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          style={{ color: "#1976d2", fontWeight: "bold" }}
        >
          Driver Registration
        </Typography>

        {/* Progress Indicator */}
        <Box display="flex" justifyContent="center" marginBottom="30px">
          <Box
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: step === 1 ? "#1976d2" : "#c5c5c5",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "10px",
            }}
          >
            1
          </Box>
          <Box
            style={{
              width: "60px",
              height: "2px",
              backgroundColor: step > 1 ? "#1976d2" : "#c5c5c5",
              margin: "0 10px",
            }}
          />
          <Box
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: step === 2 ? "#1976d2" : "#c5c5c5",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            2
          </Box>
          <Box
            style={{
              width: "60px",
              height: "2px",
              backgroundColor: step > 2 ? "#1976d2" : "#c5c5c5",
              margin: "0 10px",
            }}
          />
          <Box
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: step === 3 ? "#1976d2" : "#c5c5c5",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            3
          </Box>
        </Box>

        <form onSubmit={handleNextStep2}>
          {/* Step 1 */}
          {step === 1 && (
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="Email ID"
                  name="emailID"
                  value={formValues.emailID}
                  onChange={handleChange}
                  variant="standard"
                  error={emailError}
                  helperText={
                    emailError ? "Please enter a valid email address" : ""
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Password"
                  type="password"
                  name="password"
                  value={formValues.password}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="First Name"
                  name="fName"
                  value={formValues.fName}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Last Name"
                  name="lName"
                  value={formValues.lName}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth variant="standard">
                  <InputLabel>Gender</InputLabel>
                  <Select
                    name="gender"
                    value={formValues.gender}
                    onChange={handleChange}
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Mobile Number"
                  name="mobileNumber"
                  value={formValues.mobileNumber}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid> */}
              <Grid item xs={6}>
                <Box display="flex" alignItems="flex-end">
                  <FormControl
                    variant="standard"
                    size="small"
                    sx={{ minWidth: 80, mr: 1 }}
                  >
                    <Select
                      value={countryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                    >
                      <MenuItem value="91">+91</MenuItem>
                      <MenuItem value="254">+254</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    label="Mobile Number"
                    name="mobileNumber"
                    value={formValues.mobileNumber}
                    onChange={handleChange}
                    variant="standard"
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Zip Code"
                  name="zipCode"
                  value={formValues.zipCode}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Address"
                  name="address"
                  value={formValues.address}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth variant="standard">
                  <InputLabel>Driver Type</InputLabel>
                  <Select
                    name="driverType"
                    value={formValues.driverType}
                    onChange={handleChange}
                  >
                    <MenuItem value="private">Private</MenuItem>
                    <MenuItem value="shuttle">Shuttle</MenuItem>
                    <MenuItem value="schedule">Schedule</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          )}

          {step === 2 && (
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <FormControl fullWidth variant="standard">
                  <InputLabel>Partner Email ID</InputLabel>
                  <Select
                    name="partnerEmailID"
                    value={formValues.partnerselected || ""}
                    onChange={(e) => {
                      const selectedEmail = e.target.value;
                      const selectedPartner = partnerEmailOptions?.find(
                        (partner) => partner.PartnerEmailId === selectedEmail
                      );

                      setFormValues((prevValues) => {
                        const newFormValues = {
                          ...prevValues,
                          partnerselected: selectedEmail,
                          partnerEmailID:
                            selectedEmail === "custom" ? "" : selectedEmail,
                          partnerFullname:
                            selectedEmail === "custom"
                              ? ""
                              : selectedPartner?.PartnerName || "",
                          vehicles:
                            selectedEmail === "custom"
                              ? []
                              : selectedPartner?.Vehicles || [],
                        };

                        // Automatically set selectedVehicle to "custom" if partnerselected is "custom"
                        if (selectedEmail === "custom") {
                          newFormValues.selectedVehicle = "custom";
                        }

                        return newFormValues;
                      });

                      setVehicleCustom(selectedEmail === "custom");
                    }}
                  >
                    {partnerEmailOptions?.map((partner) => (
                      <MenuItem
                        key={partner.PartnerEmailId}
                        value={partner.PartnerEmailId}
                      >
                        {partner.PartnerEmailId}
                      </MenuItem>
                    ))}
                    <MenuItem value="custom">Custom</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {formValues.partnerselected === "custom" && (
                <>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Partner Name"
                      name="partnerFullname"
                      value={formValues.partnerFullname || ""}
                      onChange={(e) => {
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          partnerFullname: e.target.value,
                        }));
                      }}
                      variant="standard"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Partner Email ID"
                      name="partnerEmailID"
                      value={formValues.partnerEmailID || ""}
                      onChange={(e) => {
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          partnerEmailID: e.target.value,
                        }));
                      }}
                      variant="standard"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Password"
                      name="partnerPassword"
                      value={formValues.partnerPassword || ""}
                      onChange={(e) => {
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          partnerPassword: e.target.value,
                        }));
                      }}
                      variant="standard"
                    />
                  </Grid>
                  {/* <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Mobile Number"
                      name="partnerMobileNumber"
                      value={formValues.partnerMobileNumber || ""}
                      onChange={(e) => {
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          partnerMobileNumber: e.target.value,
                        }));
                      }}
                      variant="standard"
                    />
                  </Grid> */}
                  <Grid item xs={6}>
                    <Box display="flex" alignItems="flex-end">
                      <FormControl
                        variant="standard"
                        size="small"
                        sx={{ minWidth: 80, mr: 1 }}
                      >
                        <Select
                          value={countryCode}
                          onChange={(e) => setCountryCode(e.target.value)}
                        >
                          <MenuItem value="91">+91</MenuItem>
                          <MenuItem value="254">+254</MenuItem>
                        </Select>
                      </FormControl>
                      <TextField
                        fullWidth
                        label="Mobile Number"
                        name="partnerMobileNumber"
                        value={formValues.partnerMobileNumber || ""}
                        onChange={(e) => {
                          setFormValues((prevValues) => ({
                            ...prevValues,
                            partnerMobileNumber: e.target.value,
                          }));
                        }}
                        variant="standard"
                      />
                    </Box>
                  </Grid>
                </>
              )}

              <Grid item xs={6}>
                <FormControl fullWidth variant="standard">
                  <InputLabel>Vehicle</InputLabel>
                  <Select
                    name="selectedVehicle"
                    value={formValues.selectedVehicle || ""}
                    onChange={(e) => {
                      const selectedVehicle = e.target.value;

                      setFormValues((prevValues) => ({
                        ...prevValues,
                        selectedVehicle,
                      }));

                      setVehicleCustom(selectedVehicle === "custom");
                    }}
                    disabled={formValues.partnerselected === "custom"}
                  >
                    {formValues.vehicles?.map((vehicle, index) => (
                      <MenuItem key={index} value={vehicle.PlateNumber}>
                        <div>
                          <p>{vehicle.PlateNumber}</p>
                          <p style={{ fontSize: "75%", color: "gray" }}>
                            {/* {row.CarNumber}
                             */}
                            {vehicle.Model} - {vehicle.Color}
                          </p>
                        </div>
                        {/* {`${vehicle.PlateNumber} (${vehicle.Color} - ${vehicle.Model})`} */}
                      </MenuItem>
                    ))}
                    <MenuItem value="custom">Custom</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {vehicleCustom && (
                <>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Vehicle Number"
                      name="vehicleNumber"
                      value={formValues.vehicleNumber || ""}
                      onChange={(e) => {
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          vehicleNumber: e.target.value,
                        }));
                      }}
                      variant="standard"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Color"
                      name="vehicleColor"
                      value={formValues.vehicleColor || ""}
                      onChange={(e) => {
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          vehicleColor: e.target.value,
                        }));
                      }}
                      variant="standard"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Model"
                      name="vehicleModel"
                      value={formValues.vehicleModel || ""}
                      onChange={(e) => {
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          vehicleModel: e.target.value,
                        }));
                      }}
                      variant="standard"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Maker"
                      name="vehicleMaker"
                      value={formValues.vehicleMaker || ""}
                      onChange={(e) => {
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          vehicleMaker: e.target.value,
                        }));
                      }}
                      variant="standard"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl fullWidth variant="standard">
                      <InputLabel>Vehicle Type</InputLabel>
                      <Select
                        name="vehicleType"
                        value={formValues.vehicleType}
                        onChange={handleChange}
                      >
                        <MenuItem value="Basic">Basic</MenuItem>
                        <MenuItem value="Comfort">Comfort</MenuItem>
                        <MenuItem value="Comfort Plus">Comfort Plus</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl fullWidth variant="standard">
                      <InputLabel>Fuel Type</InputLabel>
                      <Select
                        name="fuelType"
                        value={formValues.fuelType}
                        onChange={handleChange}
                      >
                        <MenuItem value="Petrol">Petrol</MenuItem>
                        <MenuItem value="Diesel">Diesel</MenuItem>
                        <MenuItem value="CNG">CNG</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </>
              )}
            </Grid>
          )}

          {step === 3 && (
            <>
              <DriverRegistrationDriverDocument
                emailID={formValues.emailID}
                documents={driverDocuments}
                setDocuments={setDriverDocuments}
                isUploading={driverIsUploading}
                setIsUploading={setDriverIsUploading}
                setSnackbarOpen={setSnackbarOpen}
                setSnackbarMessage={setSnackbarMessage}
                vehicleCustom={vehicleCustom}
              />
            </>
          )}

          <Box display="flex" justifyContent="space-between" marginTop="20px">
            {(step === 1 || step === 2) && (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleBack}
                  disabled={step === 1}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={step === 2 ? handleNextStep2 : handleNext}
                >
                  {step === 2
                    ? isLoading
                      ? "Submitting..."
                      : "Save & Continue"
                    : "Next"}
                </Button>
              </>
            )}

            {step === 3 && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? "Submitting..." : "Finish"}
              </Button>
            )}
          </Box>
        </form>
        <Box>
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={() => setSnackbarOpen(false)}
          >
            <Alert
              onClose={() => setSnackbarOpen(false)}
              severity={snackbarMessage.includes("Error") ? "error" : "success"}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </Box>
      </Paper>
    </LocalizationProvider>
  );
};

export default DriverRegistration;
